import QueryString from "qs";

import AxiosInstance from "./axiosInstance.js";

const getBaseURL = () => process.env.REACT_APP_URL + "/advisor/api/v1/";

export function getRequest(url, params) {
  return AxiosInstance.get(url, params);
}

export function getRequestWithAuthorization(url, authorization, i18n) {
  const common = {
    Authorization: `Basic ${authorization}`,
    "Accept-Language": i18n.language || "en-US",
  };
  AxiosInstance.defaults.headers.common = common;
  return AxiosInstance.get(url);
}

export function updateLanguageInHeaders(language) {
  AxiosInstance.defaults.headers.common["Accept-Language"] =
    language || "en-US";
}

export function postRequest(url, payload, config = {}) {
  return AxiosInstance.post(url, payload, config).then((response) => {
    // If responseType is blob, return the full response
    if (config.responseType === "blob") {
      return response;
    }
    const responseData = response.data || response;
    // Add status to the response data while preserving existing structure
    if (typeof responseData === "object" && responseData !== null) {
      return {
        ...responseData,
        status: response.status,
      };
    }
    return responseData;
  });
}

export function putRequest(url, payload, config = {}) {
  return AxiosInstance.put(url, payload, config).then((response) => {
    const responseData = response.data || response;

    //For chemical library api & user level utility cost, response data is an array, we need to add status to the array while preserving existing structure
    if (Array.isArray(responseData)) {
      const result = [...responseData];
      result.status = response.status;
      return result;
    }

    if (typeof responseData === "object" && responseData !== null) {
      return {
        ...responseData,
        status: response.status,
      };
    }

    return responseData;
  });
}

export function deleteRequest(url, data = {}, config = {}) {
  return AxiosInstance.delete(url, { ...config, data }).then(
    (response) => response.data || response,
  );
}

export function patchRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.patch(url, payload).then(
    (response) => response.data || response,
  );
}

export const paramsSerializer = (params) =>
  QueryString.stringify(params, { arrayFormat: "repeat" });
